import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FieldError } from '@/components/auth/AuthLayout';
import { api } from '@/lib/customFetch';
import { changePasswordSchema, type ChangePasswordInput } from '@/lib/auth-schemas';

export function ChangePassword() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordInput>({ resolver: zodResolver(changePasswordSchema) });

  const onSubmit = handleSubmit(async (values) => {
    setSubmitting(true);
    try {
      await api.post('/auth/change-password', {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      toast.success('Senha alterada. Faça login novamente.');
      navigate('/login');
    } catch {
      // toast já mostrado pelo customFetch
    } finally {
      setSubmitting(false);
    }
  });

  return (
    <div className="container mx-auto max-w-md px-4 py-8">
      <h1 className="mb-1 text-2xl font-semibold">Alterar senha</h1>
      <p className="text-muted-foreground mb-6 text-sm">
        Por questão de segurança, todas as suas sessões serão invalidadas após a alteração.
      </p>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Label htmlFor="currentPassword">Senha atual</Label>
          <Input
            id="currentPassword"
            type="password"
            autoComplete="current-password"
            {...register('currentPassword')}
          />
          {errors.currentPassword && <FieldError>{errors.currentPassword.message}</FieldError>}
        </div>
        <div>
          <Label htmlFor="newPassword">Nova senha</Label>
          <Input
            id="newPassword"
            type="password"
            autoComplete="new-password"
            {...register('newPassword')}
          />
          {errors.newPassword && <FieldError>{errors.newPassword.message}</FieldError>}
        </div>
        <div>
          <Label htmlFor="confirmPassword">Confirmar nova senha</Label>
          <Input
            id="confirmPassword"
            type="password"
            autoComplete="new-password"
            {...register('confirmPassword')}
          />
          {errors.confirmPassword && <FieldError>{errors.confirmPassword.message}</FieldError>}
        </div>
        <Button type="submit" disabled={submitting}>
          Alterar senha
        </Button>
      </form>
    </div>
  );
}
